import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  NodeType,
  NodeTypeCategory
} from "../Base";
import { DataType, primitiveListTypes, primitiveTypes } from "../TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";

const textFormat = "Text Format";
const inputName = "input";
const inputTypeProperty = "inputType";
const schemaProperty = "inputSchema";
const schemaNameProperty = "inputSchemaName";
const templateProperty = "template";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.textFormat,
  label: textFormat,
  category: NodeTypeCategory.text,
  featureToggle: "feat-core-3998-flows-text-format-node",
  controlOutputs: [],
  dataInputs: [
    { name: inputName, type: DataType.OBJECT, hideLabel: true, required: true }
  ],
  dataOutputs: [{ name: "result", type: DataType.STRING }],
  nodeConfigProperties: [
    {
      name: inputTypeProperty,
      label: "Input Type",
      propertyType: NodeConfigPropertyType.DataType,
      clearPropertiesOnChange: [schemaProperty, schemaNameProperty],
      options: {
        dataTypes: [DataType.OBJECT, DataType.OBJECTLIST].concat(primitiveTypes).concat(primitiveListTypes),
        dataProperties: [inputName]
      }
    },
    {
      name: schemaProperty,
      label: "Input Schema",
      propertyType: NodeConfigPropertyType.Schema,
      showOnPropertyValues: {
        propertyName: inputTypeProperty,
        propertyValues: [DataType.OBJECT, DataType.OBJECTLIST, undefined]
      },
      options: {
        changeSchemaOnConnection: true,
        excludeReferences: true,
        displayProperty: schemaNameProperty,
        dataProperties: [inputName]
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    },
    {
      name: templateProperty,
      label: "Template",
      propertyType: NodeConfigPropertyType.TemplateEditor,
      options: {
        multiline: true,
        dataParam: inputName
      }
    }
  ],
  skipEvaluate: true,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const TextFormatNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
